import UltMeta, { Meta } from "./UltMeta/index";

class InboundDetectionType extends UltMeta {
    INBOUND = new Meta(1, "入库单");
    OUTBOUND = new Meta(2, "出库单");
}
export const INBOUND_DETECTION_TYPE = new InboundDetectionType();
